import React from "react";
import { useParams } from "react-router";
import InfoTooltip from "@/components/UI/InfoTooltip";
import GuideButton from "@/components/UI/GuideButton";
import FetchWrapper from "@/components/UI/FetchWraper";
import TableDowloadButton from "@/components/UI/DownloadTable";
import ScreeningCards from "@/components/Screening/Cards/ScreeningCards";
import MedicalHistoryTable from "@/components/Screening/Table/MedicalHistoryTable";

const SingleSubjectScreening = () => {
  const { subjectId } = useParams();

  return (
    <FetchWrapper endpointSuffix={`screening/${subjectId}/`}>
      {(data) => <SingleSubjectScreeningComponent data={data} />}
    </FetchWrapper>
  );
};
export default SingleSubjectScreening;

const SingleSubjectScreeningComponent = ({ data }: any) => {
  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <h1
            className="text-[15px] font-semibold"
            data-testid="screening-page-subtitle"
          >
            Screening
          </h1>
          <InfoTooltip
            title="These cards summarize screening data such as eligibility criteria, consent versions, disease history, and study arm information if available. Expand a card to see its full historical record."
            data-testid="screening-subtitle-tooltip"
            fill="#00000073"
          />
        </div>
        <div className="flex gap-[10px] items-center ">
          <TableDowloadButton
            data={data}
            name="subject-screening"
            subjectId={data.cards.subject}
            downloadImages
          />
          <GuideButton pageName="/wiki/guides/exploration-singlesubject-screening" />
        </div>
      </div>
      <div className="flex flex-col gap-[50px]">
        <ScreeningCards
          cardsData={data.cards}
          ieData={data.ie}
          consentData={data.consent}
          indicationEventData={data.indication_events ?? []}
        />
        <MedicalHistoryTable data={data.medical_history} />
      </div>
    </div>
  );
};
